module.exports = __webpack_public_path__ + "media/bootstrap-icons/skip-start-fill-9b03628f.svg";